<template>
    <div class="pa20" data-v="1.0.0.0">
        <div class="row">
            <div class="col-lg-12">
                <general-infos v-if="entity && activeStep > 1"
                               :quotation="quotation"
                               :estimationInfos="estimationInfos"
                               :vehicle="vehicle"
                               :owner="owner"
                               :seller="seller"
                />

                <div class="ibox">
                    <div class="ibox-title">
                        <h5>INSPECTION</h5>
                    </div>
                    <div class="ibox-content">
                        <div v-if="!entity || activeStep === 0" class="centerText">
                            <div class="row mb30">
                                <p class="text25px">Le client est un client:</p>
                            </div>
                            <div class="flexbox-container width360px height135px mr30 cursorPointer entityBoxCarizy boxShadow"
                                 :class="[entity === 'carizy' ? 'blueBorders' : 'greyBorders']"
                                 @click="setEntity('carizy')"
                            >
                                <div class="part2 centerText">
                                    <div >
                                        <img
                                            class="entityLogo"
                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0WQUthtkW71rbFdy08PApo7TcfXkCfUjuRkX4TPjOMX95VgLdlQ"
                                            alt=""
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="row pa20" v-if="entity && activeStep === 0">
                                <button
                                        @click="goToNextStep(1)"
                                        type="button"
                                        class="btn btn-w-m pull-right"
                                        :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                                >
                                    Suivant
                                </button>
                            </div>
                        </div>
                        <div v-else-if="entity && activeStep > 0" class="owner-wizard">
                            <ul v-if="entity === 'renault'" class="steps step-expertise-add">
                                <li v-for="(step, index) in steps"
                                    :key="index"
                                    :class="[index + 1 === activeStep ? 'activeRenault' : (index + 1 <= activeStepMax ? 'allowedRenault' : 'disabledRenault')]"
                                    @click="toggleBlock(index + 1)"
                                >{{ index + 1 }}. {{ step }}</li>
                            </ul>
                            <ul v-else class="steps step-expertise-add">
                                <li v-for="(step, index) in steps"
                                    :key="index"
                                    :class="[index + 1 === activeStep ? 'activeCarizy' : (index + 1 <= activeStepMax ? 'allowedCarizy' : 'disabledCarizy')]"
                                    @click="toggleBlock(index + 1)"
                                >{{ index + 1 }}. {{ step }}</li>
                            </ul>

                            <keep-alive>
                                <component
                                        :is="component"
                                        :activeStep="activeStep"
                                        :entity="entity"
                                        :userInfos="userInfos"
                                        :vehicle="vehicle"
                                        :quotation="quotation"
                                        :estimationInfosProp="estimationInfos"
                                        :vehicleInfosProp="vehicleInfos"
                                        :sellerInfosProp="sellerInfos"
                                        :meetingRequestInfosProp="meetingRequestInfos"
                                        :key="componentKey"
                                        v-on:pass-quotation-data="updateQuotationData"
                                        v-on:pass-vehicle-data="updateVehicleData"
                                        v-on:pass-estimation-infos-data="updateEstimationInfosData"
                                        v-on:pass-vehicle-infos-data="updateVehicleInfosData"
                                        v-on:pass-seller-infos-data="updateSellerInfosData"
                                        v-on:pass-meeting-request-infos-data="updateMeetingRequestInfosData"
                                        v-on:go-to-previous-step="goToPreviousStep"
                                        v-on:go-to-next-step="goToNextStep"/>
                            </keep-alive>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import GeneralInfos from '../components/details/expertiseAdd/GeneralInfos'
    import ExpertiseAddIdentification from '../components/details/expertiseAdd/Identification'
    import ExpertiseAddEstimation from '../components/details/expertiseAdd/Estimation'
    import ExpertiseAddVehicle from '../components/details/expertiseAdd/Vehicle'
    import ExpertiseAddSeller from '../components/details/expertiseAdd/Seller'
    import ExpertiseAddMeetingRequest from '../components/details/expertiseAdd/MeetingRequest'
    import ExpertiseAddRecapitulatif from '../components/details/expertiseAdd/Recapitulatif'
    import store from '../config/store'
    import router from "@/router";

    export default {
        name: "ExpertiseCreate",

        components: {
            GeneralInfos,
            'expertiseAddIdentification': ExpertiseAddIdentification,
            'expertiseAddEstimation': ExpertiseAddEstimation,
            'expertiseAddVehicle': ExpertiseAddVehicle,
            'expertiseAddSeller': ExpertiseAddSeller,
            'expertiseAddMeetingRequest': ExpertiseAddMeetingRequest,
            'expertiseAddRecapitulatif': ExpertiseAddRecapitulatif,
        },

        data: () => ({
            blocks: [
                'expertiseAddIdentification',
                'expertiseAddEstimation',
                'expertiseAddVehicle',
                'expertiseAddSeller',
                'expertiseAddMeetingRequest',
                'expertiseAddRecapitulatif'
            ],
            steps: [
                'Identification',
                'Estimation',
                'Qualification',
                'Vendeur',
                'Rendez-vous',
                'Récapitulatif'
            ],
            activeStep: 1,
            activeStepMax: 1,
            componentKey: 1,
            entity: "",
            vehicle: null,
            quotation: null,
            estimationInfos: null,
            vehicleInfos: null,
            sellerInfos: null,
            meetingRequestInfos: null,
            owner: {
                civility: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                dateOfBirth: "",
                address: "",
                companyName: "",
                siretNumber: ""
            },
            seller: {
                civility: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                dateOfBirth: "",
                address: ""
            },
            userInfos: {
                userProfil: null,
                userIsManager: false,
                managerId: "",
                userIsExpert: false,
                expertId: "",
                expertiseCompany: ""
            }    
        }),

        computed: {
            component () {
                return this.blocks[this.activeStep - 1]
            },
        },

        mounted () {
            this.scrollToTop()
            if (store.data.userInfos) {
                this.userInfos = store.data.userInfos
            } else {
                router.push('/logout')
                this.showBanner('danger', "Désolé, les informations de l'utilisateur connecté ne sont pas disponibles, veuillez vous re-connecter.")
            }
        },

        methods: {
            scrollToTop() {
                window.scrollTo(0,0);
            },
            toggleBlock (step) {
                if(this.activeStep < 6) {
                    if(step > 1 && step <= this.activeStepMax){
                        this.componentKey += 1
                        this.activeStep = step
                    } else {
                        this.showBanner('danger', "Désolé, ce changement d'étape n'est pas autorisé.")
                    } 
                } else {
                    this.showBanner('danger', "Désolé, vous ne pouvez plus retourner aux étapes précédentes.")
                }   
            },
            goToPreviousStep (step) {
                this.componentKey += 1
                this.activeStep = step
            },
            goToNextStep (step) {
                this.componentKey += 1
                this.activeStep = step
                if(step > this.activeStepMax){
                    this.activeStepMax = step
                }
            },
            setEntity (entity) {
                this.entity = entity
                this.activeStep = 1
            },
            updateQuotationData (quotation) {
                this.quotation = quotation
            },
            updateVehicleData (vehicle) {
                this.vehicle = vehicle
            },
            updateEstimationInfosData (estimationInfos) {
                this.estimationInfos = estimationInfos
            },
            updateVehicleInfosData (vehicleInfos) {
                this.vehicleInfos = vehicleInfos
            },
            updateSellerInfosData (sellerInfos) {
                this.sellerInfos = sellerInfos
                this.owner = sellerInfos.owner
                this.seller = sellerInfos.seller
            },
            updateMeetingRequestInfosData (meetingRequestInfos) {
                this.meetingRequestInfos = meetingRequestInfos
            },
        },
    }
</script>

<style scoped>

</style>
